import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Header } from 'semantic-ui-react';
import { withFormik } from 'formik';
import { withApollo, compose } from 'react-apollo';

import Form from './Form';
import ListWithData from './ListWithData';

class ClaimSearch extends Component {
  state = {};

  handleDateFilterChange = date =>
    this.props.setFieldValue(
      'flightDate',
      date ? moment(date).format('YYYY-MM-DDTHH:mm') : undefined
    );

  handleSingleFilterAdd = (filter, e, { value }) => {
    const filterValue = value ? [value] : [];
    this.props.setFieldValue(filter, filterValue);
  };

  handleMultipleFilterAdd = (filter, e, { value }) => {
    const isFilterPresent = this.props.values[filter].indexOf(value[0]) !== -1;
    if (!isFilterPresent) {
      const filterValue = [...this.props.values[filter], ...value];
      this.props.setFieldValue(filter, filterValue);
    }
  };

  handleFilterDelete = (value, filter) => {
    const { values, setFieldValue } = this.props;
    const indexToDelete = values[filter].indexOf(value);
    const filterValue = [...values[filter]];
    filterValue.splice(indexToDelete, 1);
    setFieldValue(filter, filterValue);
  };

  handleSubmit = () => this.setState({ filter: this.props.values });

  render() {
    const { onAssignClick, onReject, values } = this.props;
    const { filter } = this.state;
    return (
      <Fragment>
        <Header>Claim Search</Header>
        <Form
          values={values}
          onSubmit={this.handleSubmit}
          onMultipleFilterAdd={this.handleMultipleFilterAdd}
          onSingleFilterAdd={this.handleSingleFilterAdd}
          onReject={onReject}
          onDateFilterChange={this.handleDateFilterChange}
          onFilterDelete={this.handleFilterDelete}
        />
        {filter && <ListWithData filter={filter} onAssignClick={onAssignClick} />}
      </Fragment>
    );
  }
}

const formikConfig = {
  enableReinitialize: true,
  mapPropsToValues: props => ({
    flightNumbers: [],
    airlineNames: [],
    countryNames: [],
    reasons: [],
    passengerFullNames: [],
    claimCodes: [],
    pnrs: [],
    tokens: [],
    passengerEmails: []
  })
};

export default compose(
  withApollo,
  withFormik(formikConfig)
)(ClaimSearch);



// WEBPACK FOOTER //
// ./src/component/tasks/AssignMessageTask/ClaimSearch/index.js